import { Injectable } from '@angular/core';

import { environment } from '../environment';

import { Http2, Http2Factory } from './http2-factory';

@Injectable()
export class Api {
    public http2: Http2;
    constructor(public http2Factory: Http2Factory) {
        this.http2 = http2Factory.create(environment.apiBaseUrl, environment.pdauthAppName, true);
    }

    async getAssetIds(intId: number[], stringId: string[], query: string) {
        return await this.http2.graphqlRequest(`
                query GetAssets($intId: [Int], $stringId: [String]) {
                    ${query}
                }
        `,                                     { intId, stringId }, 'GET', '');
    }

    public pick(obj: { [key: string]: any }, props: string[]) {
        if (!obj) { return obj; }
        const retVal: { [key: string]: any } = {};
        for (const key in obj) {
            if (props.includes(key)) {
                retVal[key] = obj[key];
            }
        }
        return retVal;
    }

    /**
     * The only way to set a cookie on the other domains is to open an IFrame and make a request to that domain
     * and ask it to set a cookie itself. This method creates an iframe, sends the request, and then deletes the iframe.
     */
    public _pendingIFrames: any[] = [];
    public setCookieInIFrame(token: string, setCookieUrl: string): Promise<string | Event> {
        return new Promise<string | Event>((resolve, _reject) => {
            if (token === null || token === undefined) {
                token = '';
            }
            const url = setCookieUrl + `?value=${token}`;
            const iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.style.display = 'none';
            iframe.style.height = '0';
            iframe.style.width = '0';
            iframe.style.opacity = '0';
            this._pendingIFrames.push(iframe);
            iframe.onload = (e) => {
                resolve(e);
                document.body.removeChild(iframe);
                this._pendingIFrames.splice(this._pendingIFrames.indexOf(iframe), 1);
            };
            iframe.onerror = (e) => {
                resolve(e);
                console.error('Set cookie failed: ', e);
            };
            iframe.onabort = <any>iframe.onerror;
            document.body.appendChild(iframe);
        });
    }
}
